<template>
  <div id="small-auth" :class="{ 'log-in': !formData.isShowingLogin }">
    <div class="card" :class="{ 'flip-scale-2-ver-right': showPasswordReset }">
      <div class="card-header" :class="{ 'flip-scale-2-ver-right': showPasswordReset }">
        <img
          class="form-item-logo"
          :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
          :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
        />
        <BushelBtn variant="primary" outline :ripple="false" class="float-right mt-1" style="width: 80px" @click="$emit('toggleLoginView')">
          <transition name="text-blur-out" mode="out-in">
            <span v-if="formData.isShowingLogin" key="loginbtn" class="nowrap">Sign Up</span>
            <span v-else-if="!formData.isShowingLogin" key="logoutbtn" class="nowrap">Log In</span>
          </transition>
        </BushelBtn>
      </div>
      <div class="card-body">
        <transition name="text-blur-out" mode="out-in">
          <div v-if="formData.isShowingLogin" key="login" class="form-group form-item log-in">
            <Login :form-data="formData" @input="$emit('input', $event)" />
          </div>
          <div v-else-if="!formData.isShowingLogin" key="logout" class="form-group form-item sign-up">
            <Register
              :form-data="formData"
              :countries="countries"
              :joining-company-name="joiningCompanyName"
              :states="states"
              :subscription-types="subscriptionTypes"
              :create-brand="createBrand"
              @input="$emit('input', $event)"
            />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Login from "./Login.vue";
import Register from "./Register.vue";

export default {
  components: { Login, Register },
  props: {
    formData: { type: Object, required: true },
    countries: { type: Array, required: true },
    joiningCompanyName: { type: String },
    states: { type: Array, required: true },
    subscriptionTypes: { type: Array, required: true },
    createBrand: { type: Boolean, default: false },
  },
  emits: ["input"],
  data() {
    return {
      industry: APP_INDUSTRY,
      isShowingLogin: true,
      showPassword: false,
      acceptTerms: false,
      showTerms: false,
      showPasswordReset: false,
      email: "",
      password: "",
      passwordConfirm: "",
      valid: false,
      name: "",
      phone: "",
    };
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@sass/_variables.scss";

#small-auth {
  margin: 0.5rem auto;
  margin-top: 0rem;
  padding-top: 1rem;
  position: relative;
  width: min-content;
  max-width: 23rem;
  width: 100%;

  input {
    margin: 0 auto 15px;
    display: block;
    padding: 10px 15px;
    width: 220px;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  .card {
    border-radius: 1rem;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);

    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem;
      background: transparent;
      border: 0;

      .form-item-logo {
        width: 112px;
        float: left;
      }
    }

    .card-body {
      background-color: transparent;

      .form-item {
        width: 100%;
        height: 100%;
        opacity: 1;
        -moz-transition: all 0.5s;
        -o-transition: all 0.5s;
        -webkit-transition: all 0.5s;
        transition: all 0.5s;

        &.sign-up {
          top: 50px;
        }
      }
    }
  }
}

.text-blur-out-enter-active {
  animation: text-focus-in 1s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.text-blur-out-leave-active {
  animation: text-blur-out 1.2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

@keyframes text-focus-in {
  0% {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@keyframes text-blur-out {
  0% {
    -webkit-filter: blur(0.01);
    filter: blur(0.01);
  }
  100% {
    -webkit-filter: blur(12px) opacity(0%);
    filter: blur(12px) opacity(0%);
  }
}
</style>
